export const TeacherDashboard = () => {
  return <h1>Teacher Dashboard</h1>;
};
